<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsRealestateAnalysis')}}</b></span><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-icon small>fa-info-circle</v-icon><span style="display:inline-block; padding-left:10px; color:grey; font-size:13px;">{{$t('labels.reportsWaitTime')}}</span><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs3>
				<v-layout row wrap>
					<v-flex md6 xs12>
						<v-btn color="grey lighten-1" @click="deleteFilters" style="width:95%">
							{{ $t('buttons.deleteFilters') }}
						</v-btn><br>
					</v-flex>
					<v-flex md6 xs12>
						<v-btn color="grey lighten-1" @click="getData" style="width:95%">
							{{ $t('buttons.fetchData') }}
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-1>
			<v-flex xs12>
				<DataTable
						ref="dataTable"
						:excel="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.link, false)">{{ props.item.vtiger_id }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.realestate_type }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.owner_contact }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.owner_organization }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_offerings }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_views }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_recieved_offers }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_price_changes }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.date_of_contract_start }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.date_of_contract_expiration }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.sales_stage }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.build_stage }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.expected_finish_date }}</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.pairing">fa-check</v-icon>
								</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.complete_documentation">fa-check</v-icon>
								</td>
							</tr>
						</template>
					</DataTable>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";
import InputField from "./trinkets/InputField";

export default {
	name: "ReportsRealestateAnalysis",
	components: {DataTable, InputField},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.realestateId'), value: 'vtiger_id', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.realestateType'), value: 'realestate_type', type: 'multiple|realestate-type', searchable: 'hidden'},
					{text: this.$t('fields.ownerContact'), value: 'owner_contact', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.ownerOrganisation'), value: 'owner_organization', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.totalOfferings'), value: 'total_offerings', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalViews'), value: 'total_views', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalRecievedOffers'), value: 'total_recieved_offers', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalPriceChanges'), value: 'total_price_changes', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.dateOfContactStart'), value: 'date_of_contract_start', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.dateOfContactExpiration'), value: 'date_of_contract_expiration', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.salesStage'), value: 'sales_stage', type: 'multiple|sales-stage', searchable: 'hidden'},
					{text: this.$t('fields.buildStage'), value: 'build_stage', type: 'multiple|realestate-status', searchable: 'hidden'},
					{text: this.$t('fields.expectedFinishDate'), value: 'expected_finish_date', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.pairing'), value: 'pairing', type: 'boolean', searchable: 'hidden'},
					{text: this.$t('fields.completeDocumentation'), value: 'complete_documentation', type: 'boolean', searchable: 'hidden'}
				],
				items: [],
				total: 0,
				lastRequest: null
			}
		}
	},
	methods: {
		deleteFilters(){
			let dataTable = this.$refs.dataTable;
			dataTable.resetFilter();
			dataTable.filter = false;
		},
		getData(){
			let dataTable = this.$refs.dataTable;
			dataTable.filter = false;
			let vm = this;
			this.$APICall('get', 'report-realestate-analysis', this.lastRequest, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		reloadData(request) {
			this.lastRequest = request;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'report-realestate-analysis', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/report-realestate-analysis', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		editClick(link){
			if(link != null && link != ''){
				window.open(link);
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
